export default __webpack_public_path__ + "static/media/Group-3406_yono.42af3172.png";